import { useState, useEffect, useContext, useReducer, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import { useTable, usePagination, useSortBy, useFilters } from 'react-table';
import "../../css/ListUsers.css";
import Header from "../Navigation/Header";
import Footer from "../Navigation/Footer";
//import UserReadOnlyRow from "../../components/UserReadOnlyRow";
import UserModal from "../../components/UserModal";
import UserAppAccessTable from "../../components/UserAppAccessTable";
import UserDetailsModal from "../../components/UserDetailsModal";

import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import { useQuery } from 'react-query';
import UsersFilter from "./DataFilter";
import { useTranslation } from 'react-i18next';
import { scrollToTop } from "../../utils/helper.js";
import { matchSorterFn, sortItems } from "../../utils/sorting";
import { TextSearchFilter } from "../../utils/filter";
import NeverLoggedInUsers from "../../components/NeverLoggedInUsers";

const initialState = {
    queryPageIndex: 0,
    queryPageSize: 25,
    totalCount: 0,
    queryPageFilter: "",
};

const PAGE_CHANGED = 'PAGE_CHANGED';
const TOTAL_COUNT_CHANGED = 'TOTAL_COUNT_CHANGED';
const PAGE_FILTER_CHANGED = 'PAGE_FILTER_CHANGED';

const reducer = (state, { type, payload, t }) => {
    switch (type) {
        case PAGE_CHANGED:
            return {
                ...state,
                queryPageIndex: payload,
            };
        case TOTAL_COUNT_CHANGED:
            return {
                ...state,
                totalCount: payload,
            };
        case PAGE_FILTER_CHANGED:
            return {
                ...state,
                queryPageFilter: payload.trim(),
                queryPageIndex: 0,
            };
        default:
            throw new Error(t("error.unhandledException") + " : ${type}");
    }
};

let prevCount = 0;
function setPrevCount(newCount) {
    prevCount = newCount;
}

function ListUsers() {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [errorValue, setErrorValue] = useState("");
    const [data, setData] = useState([]);
    const [keyCount, setKeyCount] = useState(0);

    const [count, setCount] = useState(0);
    const [keyword, setKeyword] = useState("");
    const [useFilter, setUseFilter] = useState(false);
    const { t } = useTranslation();
    const userCtx = useContext(UserContext);
    const [add, setAdd] = useState(false);
    const [appAccess, setAppAccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [appNames, setAppNames] = useState([]);
    const [roles, setRoles] = useState([]);
    const [fidesRoles, setFidesRoles] = useState([]);
    const [factbookRoles, setFactbookRoles] = useState([]);
    const [fairRoles, setFairRoles] = useState([]);
    const [idirtRoles, setIdirtRoles] = useState([]);
    const [cristalRoles, setCristalRoles] = useState([]);
    const [details, setDetails] = useState(false);
    const [neverLoggedIn, setNeverLoggedIn] = useState(false);
    const [{ queryPageIndex, queryPageSize, totalCount, queryPageFilter }, dispatch] =
        useReducer(reducer, initialState);
    let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
    const defaultColumn = useMemo(() => ({
        // Let's set up our default Filter UI
        Filter: ""
    }), []
    );
    const filterTypes = useMemo(() => ({
        rankedMatchSorter: matchSorterFn
    }),
        []
    );
    const columns = useMemo(
        () => [
            {
                id: 'userId',
                accessor: 'userId',
                Header: () => t("page.id"),
                minWidth: '10vw',
                maxWidth: '15vw',
                Filter: TextSearchFilter,
                filter: "rankedMatchSorter",
                sortType: (prev, curr, columnId) => {
                    return sortItems(prev, curr, columnId);
                },
            },
            {
                id: 'userName',
                accessor: 'userName',
                Header: () => t("page.name"),
                minWidth: '10vw',
                maxWidth: '12vw',
                Filter: TextSearchFilter,
                filter: "rankedMatchSorter",
                sortType: (prev, curr, columnId) => {
                    return sortItems(prev, curr, columnId);
                },
            },
            {
                id: 'companyName',
                accessor: 'companyName',
                Header: () => t("page.company.name"),
                minWidth: '10vw',
                maxWidth: '14vw',
                Filter: TextSearchFilter,
                filter: "rankedMatchSorter",
                sortType: (prev, curr, columnId) => {
                    return sortItems(prev, curr, columnId);
                },
            },
            {
                accessor: 'address',
                Header: () => t("page.address"),
                minWidth: '14vw',
                maxWidth: '14vw',
                disableSortBy: true,
            },
            {
                accessor: 'phone',
                Header: () => t("page.phone"),
                minWidth: '5vw',
                maxWidth: '5vw',
                disableSortBy: true,
            },
            {
                accessor: 'appNames',
                Header: () => t("page.appAccess"),
                minWidth: '12vw',
                maxWidth: '12vw',
                disableSortBy: true,
            },

            {
                accessor: 'role',
                Header: () => t("page.role"),
                minWidth: '6vw',
                maxWidth: '6vw',
                disableSortBy: true,
            },
            {
                accessor: 'status',
                Header: () => t("page.status"),
                minWidth: '5vw',
                maxWidth: '5vw',
                disableSortBy: true,
                sortType: (prev, curr, columnId) => {
                    return sortItems(prev, curr, columnId);
                },
            },
            {
                accessor: 'action',
                id: 'action',
                Header: () => t("page.action"),
                minWidth: '10vw',
                maxWidth: '15vw',
                disableSortBy: true,
            },
        ],
        []
    )

    const pageData = useMemo(() => {
        return data ? data : []
    }, [data]);
    //const [columns, setColumns] = useState([]);
    useEffect(() => {
        fetchRoles();
        fetchAppNames();
    }, []);


    const initialValues = {
        userId: "",
        userName: "",
        password: "",
        email: "",
        address1: "",
        address2: "",
        phone: "",
        zipCode: "",
        zipExt: "",
        city: "",
        stateKey: 0,
        interestKey: 0,
        roleKey: 0,
        role: "",
        appAccess: [],
        stateCode: "",
        stateName: "",
        countryCode: "US",
        countryName: "United States of America",
        userTimeZone: "America/Los_Angeles",
        userLanguage: "en",
        updatedById: "",
        companyId: 0,
        companyName: "",
        companyCity: "",
        companyStateCode: "",
        companyCountryCode: "",
        userType: "CORP",
        userSubType: "Employee",
    };
    const [editFormData, setEditFormData] = useState(initialValues);


    const { isError, error, isSuccess, refetch } = useQuery(
        ['user-list', queryPageIndex, queryPageSize, queryPageFilter],
        () => retrieveUsers(queryPageIndex, queryPageSize, queryPageFilter),
        {
            keepPreviousData: false,
            staleTime: 1000,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        }
    );


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        rows,
        prepareRow,
        // Get the state from the instance
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns: columns,
            data: pageData,
            filterTypes,
            defaultColumn,
            initialState: {
                pageIndex: queryPageIndex,
                pageSize: queryPageSize,
                sortBy: [
                    {
                        id: 'status',
                        desc: false
                    },
                    {
                        id: 'userId',
                        desc: false
                    },
                    {
                        id: 'userName',
                        desc: false
                    },
                    {
                        id: 'companyName',
                        desc: false
                    }
                ]
            },
            manualPagination: true,
            pageCount: isSuccess ? Math.ceil(count / queryPageSize) : null,
        }, useSortBy, usePagination, useFilters
    );

    useEffect(() => {
        dispatch({ type: PAGE_CHANGED, payload: pageIndex, t: t });
    }, [pageIndex]);

    useEffect(() => {
        if (count !== prevCount) {
            dispatch({
                type: TOTAL_COUNT_CHANGED,
                payload: count,
                t: t
            });

            setPrevCount(count);
        }
    }, [count]);

    useEffect(() => {
        if (useFilter) {
            dispatch({ type: PAGE_FILTER_CHANGED, payload: keyword, t: t });
            gotoPage(0);
        }

    }, [keyword, useFilter, gotoPage]);

    function retrieveUsers(page, dispSize, searchFilter) {
        setErrorValue("");
        setIsLoading(true);
        const offset = page * dispSize;
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true,
                offset: offset, limit: dispSize, searchValue: searchFilter,
                userCompanyId: userCompanyId
            }),
        };
        try {
            FetchUtil.fetchAPI("FetchUsers", "/Service/UserService/FetchUsers", requestOptions, retrieveUsersSuccess, retrieveUsersFail);
        } catch (error) {
            setIsLoading(false);
            console.log(error.message);
            throw new Error(error.message);
        }
    }

    function retrieveUsersFail(redirect) {
        setIsLoading(false);
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.userListNotRetrieved"));
    }

    function retrieveUsersSuccess(responseData) {
        let fetchUsersResponse;
        if (responseData) {
            fetchUsersResponse = responseData.fetchUsersResponse;
            if (fetchUsersResponse && fetchUsersResponse.errorCode === "0") {
                setData(fetchUsersResponse.users.slice());
                if (fetchUsersResponse.offset === 0) {
                    setCount(fetchUsersResponse.totalCount);
                }
            } else if (fetchUsersResponse && fetchUsersResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchUsersResponse) {
                setErrorValue(t("error.error") + " " + fetchUsersResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
        setIsLoading(false);
    }
    function fetchRoles() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false }),
        };
        try {
            FetchUtil.fetchAPI("MGetRoles", "/Service/StaticHelper/GetRoles", requestOptions, getRolesSuccess, getRolesFail);
        } catch (error) {
            setErrorValue(error.message);
        }
    }

    function getRolesFail(redirect) {
        setError(t("error.getRoleFailed"));
    }
    function getRolesSuccess(responseData) {
        let rolesResponse;
        if (responseData) {
            rolesResponse = responseData.getRolesResponse;
            if (rolesResponse && rolesResponse.errorCode === "0") {
                setRoles([...roles, ...rolesResponse.roles]);
                setFidesRoles([...fidesRoles, ...rolesResponse.fidesRoles]);
                setFactbookRoles([...factbookRoles, ...rolesResponse.factbookRoles]);
                setFairRoles([...fairRoles, ...rolesResponse.fairRoles]);
                setIdirtRoles([...idirtRoles, ...rolesResponse.idirtRoles]);
                setCristalRoles([...cristalRoles, ...rolesResponse.cristalRoles]);
            } else if (rolesResponse) {
                setErrorValue(t("error.error") + " " + rolesResponse.errorMessage);
            }
        }
    }
    function fetchAppNames() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false }),
        };
        try {
            FetchUtil.fetchAPI("MGetAppNames", "/Service/StaticHelper/GetAppNames", requestOptions, getAppNamesSuccess, getAppNamesFail);
        } catch (error) {
            setErrorValue(error.message);
        }
    }

    function getAppNamesFail(redirect) {
        setErrorValue(t("error.getAppNamesFailed"));
    }
    function getAppNamesSuccess(responseData) {
        let appNameResponse;
        if (responseData) {
            appNameResponse = responseData.getAppNameResponse;
            if (appNameResponse && appNameResponse.errorCode === "0") {
                setAppNames([...appNames, ...appNameResponse.appNames]);
            } else if (appNameResponse) {
                setErrorValue(t("error.error") + " " + appNameResponse.errorMessage);
            }
        }
    }
    const handleEditClick = (event, user) => {
        event.preventDefault();
        event.stopPropagation();
        setErrorValue("");
        let formData = JSON.parse(JSON.stringify(user));
        setEditFormData({ ...editFormData, ...formData });
        setShow(true);
        setAdd(false);
        setAppAccess(false);
        setDetails(false);
        setNeverLoggedIn(false);
    };

    const handleDetailsClick = (event, user) => {
        event.preventDefault();
        event.stopPropagation();
        setErrorValue("");
        let formData = JSON.parse(JSON.stringify(user));
        setEditFormData({ ...editFormData, ...formData });
        setShow(false);
        setAdd(false);
        setAppAccess(false);
        setDetails(true);
        setNeverLoggedIn(false);
    };

    const handleDeleteDetailsClick = (event, user) => {
        event.preventDefault();
        setErrorValue("");
        if (window.confirm(t("confirm.delete.details"))) {
            deleteUserDetails(user.userId);
        }
    };

    const deleteUserDetails = (userId) => {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", loginId: userId,
                userId: userCtx.loggedInUserId,
                updatedById: userCtx.loggedInUserId
            }),
        };
        try {
            FetchUtil.fetchAPI("DeleteUserDetails", "/Service/UserService/DeleteUserDetails", requestOptions, deleteUserDetailsSuccess, deleteUserDetailsFail);
        } catch (error) {
            setErrorValue(error.message);
        }
    }

    function deleteUserDetailsFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.userDetailsDeleteFailed"));
    }
    function deleteUserDetailsSuccess(responseData) {
        let deleteUserDetailsResponse;
        if (responseData) {
            deleteUserDetailsResponse = responseData.deleteUserDetailsResponse;
            if (deleteUserDetailsResponse && deleteUserDetailsResponse.errorCode === "0") {
                // only retrieve the modified user
                handleRefresh();
            } else if (deleteUserDetailsResponse && deleteUserDetailsResponse.errorCode === "102") {
                handleRefresh();
                setErrorValue(t("error.error") + " " + deleteUserDetailsResponse.errorMessage);
            } else if (deleteUserDetailsResponse) {
                handleRefresh();
                setErrorValue(t("error.error") + " " + deleteUserDetailsResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.update"));
            }
        }
    }

    const handleDeleteClick = (event, userId, statusCode) => {
        event.preventDefault();
        setErrorValue("");
        deleteUser(userId, statusCode);
    };

    const deleteUser = (userId, statusCode) => {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", loginId: userId,
                statusCode: statusCode, updatedById: userCtx.loggedInUserId
            }),
        };
        try {
            FetchUtil.fetchAPI("DeleteUser", "/Service/UserService/DeleteUser", requestOptions, deleteUsersSuccess, deleteUsersFail);
        } catch (error) {
            setErrorValue(error.message);
        }
    }

    function deleteUsersFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.userDeleteFailed"));
    }
    function deleteUsersSuccess(responseData) {
        let deleteUserResponse;
        if (responseData) {
            deleteUserResponse = responseData.deleteUserResponse;
            if (deleteUserResponse && deleteUserResponse.errorCode === "0") {
                // only retrieve the modified user
                handleRefresh();
            } else if (deleteUserResponse && deleteUserResponse.errorCode === "102") {
                handleRefresh();
                setErrorValue(t("error.error") + " " + deleteUserResponse.errorMessage);

            } else if (deleteUserResponse) {
                handleRefresh();
                setErrorValue(t("error.error") + " " + deleteUserResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.update"));
            }
        }
    }

    const onClickFilterCallback = (searchFilter) => {
        if (searchFilter === keyword) {
            //console.log('No change in search')
            return
        }
        setUseFilter(true);
        setKeyword(searchFilter);
    }
    const handleAddClick = (event) => {
        event.preventDefault();
        setErrorValue("");
        setShow(true);
        setAdd(true);
        setAppAccess(false);
        setDetails(false);
        setNeverLoggedIn(false);
        setEditFormData(initialValues);
    }

    const handleVerifyEmailClick = (event) => {
        event.preventDefault();
        setErrorValue("");
        setShow(false);
        setAdd(false);
        setAppAccess(false);
        setDetails(false);
        setNeverLoggedIn(true);
    }


    if (isError) {
        setErrorValue(t("error.error") + " " + error.message);
    }

    const handleAppAccessClick = (event, user) => {
        event.preventDefault();
        event.stopPropagation();
        setErrorValue("");
        let formData = JSON.parse(JSON.stringify(user));
        setEditFormData({ ...editFormData, ...formData });
        setShow(false);
        setAdd(false);
        setDetails(false);
        scrollToTop();
        setAppAccess(true);
        setNeverLoggedIn(false);
    };


    const handleRefresh = () => {
        refetch();
        setKeyCount(prevCount => prevCount + 1);
    };

    return (
        <div className="container-fluid">
            <Header />
            <div className={(show || appAccess || details) ? "container-fluid container_list viewh-85 pe-none" : "container-fluid container_list viewh-85"}>
                {(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
                    <>
                        <div className="row">
                            <div className="col">
                                <div
                                    id="inerrorMessage"
                                    className={
                                        (errorValue) ? "errorblock" : "errorblock hide"
                                    }
                                >
                                    {errorValue ? errorValue : ""}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <div id="placeholder_1" className="placeholder-pg"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <UsersFilter t={t} onClickFilterCallback={onClickFilterCallback} defaultKeyword={keyword} />
                            </div>
                            {(isLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                        </div>
                        <div className="row">
                            <div className="col">
                                <div id="placeholder_2" className="placeholder-pg"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                            </div>
                            <div className="col-3">
                                <button className="btn btn-primary btn-block me-4" data-toggle="modal" data-target="#userModal"
                                    onClick={(event) => handleAddClick(event)}>{t("header.admin.addUser")}</button>
                            </div>
                            {(userCtx.role === "SiteAdmin") ?
                                <>
                                    <div className="col-3">
                                        <button className="btn btn-primary btn-block me-4"
                                            onClick={(event) => handleVerifyEmailClick(event)}>{t("header.admin.neverLoggedInUsers")}</button>
                                    </div>
                                    <div className="col-3">
                                    </div>
                                </>
                                : <div className="col-6">
                                </div>}
                        </div>
                        <div className="row">
                            <div className="col">
                                <div id="placeholder_2" className="placeholder-pg"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                {isSuccess ? (
                                    <>
                                        <table key={keyCount} className="list-table" {...getTableProps()}>
                                            <thead>
                                                {headerGroups.map(headerGroup => (
                                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                                        {headerGroup.headers.map(column => (
                                                            <th className="list-th" {...column.getHeaderProps(column.getSortByToggleProps(), {
                                                                style: { maxWidth: column.maxWidth },
                                                            })}>{column.render("Header")}
                                                                <span className={
                                                                    (count > 0 && column.canSort) ? column.isSorted
                                                                        ? column.isSortedDesc
                                                                            ? "fa fa-sort-down"
                                                                            : "fa fa-sort-up"
                                                                        : "fa fa-sort"
                                                                        : ""
                                                                } style={{ fontSize: '24px', color: '#0c374c', float: 'right', verticalAlign: 'middle' }}>
                                                                </span>
                                                                <div>{column.canFilter ? column.render("Filter") : null}</div>
                                                            </th>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </thead>
                                            <tbody {...getTableBodyProps()}>
                                                {rows.map((row, index) => {
                                                    prepareRow(row);
                                                    let oddIdx = ((index % 2) > 0) ? true : false;
                                                    let user;
                                                    let found = false;
                                                    pageData.map((eachUser) => {
                                                        if (eachUser.userId == row.values.userId) {
                                                            user = eachUser;
                                                            found = true;
                                                        }
                                                        if (found) {
                                                            return;
                                                        }
                                                    });
                                                    return (
                                                        (row && user.userId !== userCtx.loggedInUserId) &&
                                                        <tr	{...row.getRowProps()}>
                                                            {row.cells.map((cell) => {
                                                                return (
                                                                    (cell.column.id == "action") ?
                                                                        <td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"} style={{ minWidth: "12vw" }}>
                                                                            <button className="btn btn-primary btn-block me-2 mb-1" data-toggle="modal" data-target="#userModal"
                                                                                onClick={(event) => handleEditClick(event, user)}>{t("page.edit")}</button>
                                                                            <button className="btn btn-primary btn-block me-2 mb-1" onClick={(event) => handleDeleteClick(event, user.userId, user.statusCode)}>{user.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
                                                                            <button className="btn btn-primary btn-block me-2 mb-1" onClick={(event) => handleAppAccessClick(event, user)}>{t("page.appAccess")}</button>
                                                                            {(user.companyId && user.companyId !== 0) ? (<>
                                                                                <button className="btn btn-primary btn-block me-2 mb-1" onClick={(event) => handleDetailsClick(event, user)}>{t("page.details")}</button>
                                                                            </>
                                                                            ) : (<> </>)
                                                                            }
                                                                            {(userCtx.hasDeleteAccess && userCtx.hasDeleteAccess === true) ? (<>
                                                                                <button className="btn btn-primary btn-block me-2 mb-1" onClick={(event) => handleDeleteDetailsClick(event, user)}>{t("page.delete.details")}</button>
                                                                            </>
                                                                            ) : (<> </>)
                                                                            }
                                                                        </td>
                                                                        :
                                                                        <td
                                                                            {...cell.getCellProps()}
                                                                            className={oddIdx ? "list-td col col-md-auto text-wrap odd" : "list-td col col-md-auto text-wrap even"}
                                                                            style={{
                                                                                minWidth: cell.column.minWidth,
                                                                                maxWidth: cell.column.maxWidth,
                                                                                wordBreak: "break-word",
                                                                            }}
                                                                        >
                                                                            {cell.render("Cell")}
                                                                        </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    );

                                                })}
                                            </tbody>

                                        </table>

                                        <div className="pagination">
                                            <button className="nav-button" onClick={() => { gotoPage(0); }} disabled={!canPreviousPage}>
                                                {'<<'}
                                            </button>
                                            <button className="nav-button" onClick={() => { previousPage(); }} disabled={!canPreviousPage}>
                                                {'<'}
                                            </button>
                                            <button className="nav-button" onClick={() => { nextPage(); }} disabled={!canNextPage}>
                                                {'>'}
                                            </button>
                                            <button className="nav-button"
                                                onClick={() => { gotoPage(pageCount - 1); }}
                                                disabled={!canNextPage}
                                            >
                                                {'>>'}
                                            </button>
                                            <span className="nav-page-info">{t("page.page") + ' '}
                                                <strong>
                                                    {pageOptions.length > 0 ? pageIndex + 1 : 0} {t("page.of")} {pageOptions.length}
                                                </strong>
                                            </span>
                                            <span className="nav-page-goto">{t("page.goToPage")}:{' '}
                                                <input
                                                    type="number"
                                                    value={pageIndex + 1}
                                                    onChange={(e) => {
                                                        const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                                        gotoPage(page);
                                                    }}
                                                    className="nav-goto-input"
                                                />
                                            </span>
                                        </div>
                                    </>
                                ) : <></>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3">
                            </div>
                            <div className="col-3">
                                <button className="btn btn-primary btn-block me-4 mb-1" data-toggle="modal" data-target="#userModal"
                                    onClick={(event) => handleAddClick(event)}>{t("header.admin.addUser")}</button>
                            </div>
                            {(userCtx.role === "SiteAdmin") ?
                                <>
                                    <div className="col-3">
                                        <button className="btn btn-primary btn-block me-4 mb-1"
                                            onClick={(event) => handleVerifyEmailClick(event)}>{t("header.admin.neverLoggedInUsers")}</button>
                                    </div>
                                    <div className="col-3">
                                    </div>
                                </>
                                : <div className="col-6">
                                </div>}
                        </div>
                        <div className="row">
                            <div className="col">
                                <div
                                    id="berrorMessage"
                                    className={
                                        (errorValue) ? "errorblock" : "errorblock  hide"
                                    }
                                >
                                    {errorValue ? errorValue : ""}
                                </div>
                            </div>
                        </div>
                    </>
                    : <></>}
            </div>
            <div className="footer_container">
                <Footer />
            </div>
            {show && <UserModal key={keyCount} t={t} user={editFormData} setShow={setShow} refetch={handleRefresh} add={add} roles={roles} appNames={appNames} />}
            {appAccess &&
                <UserAppAccessTable key={keyCount} setAppAccess={setAppAccess} appAccess={editFormData.appAccess} fidesRoles={fidesRoles}
                    factbookRoles={factbookRoles} fairRoles={fairRoles} idirtRoles={idirtRoles} cristalRoles={cristalRoles} appNames={appNames} userId={editFormData.userId} refetch={handleRefresh} />
            }
            {details &&
                <UserDetailsModal key={keyCount} t={t} user={editFormData} setDetails={setDetails} />
            }
            {neverLoggedIn &&
                <NeverLoggedInUsers t={t} setErrorValue={setErrorValue} setNeverLoggedIn={setNeverLoggedIn} />
            }
        </div>
    );
}

export default ListUsers;